import { ReportData } from '../types/reportTypes';
import { combineReports } from '../utils/reportAggregationUtils';
import { januaryData } from './januaryData';
import { februaryData } from './februaryData';
import { sampleData as marchData } from './sampleData'; // March data is in sampleData.ts
import { aprilData } from './aprilData';
import { mayData } from './mayData';
import { juneData } from './juneData';
import { julyData } from './julyData';
import { augustData } from './augustData';
import { septemberData } from './septemberData';
import { octoberData } from './octoberData';
import { novemberData } from './novemberData';
import { decemberData } from './decemberData';

// REMINDER: When adding a new month:
// 1. Import the new month's data above
// 2. Add it to the allMonthlyReports array below
// 3. Update the endMonth in the period object
// 4. Update the YTD report component titles
// 5. Also update codySalesYTDData.ts if Cody version exists

// All monthly reports to aggregate for YTD
// Full year 2025 complete (January-December)
const allMonthlyReports = [
  januaryData,
  februaryData,
  marchData,
  aprilData,
  mayData,
  juneData,
  julyData,
  augustData,
  septemberData,
  octoberData,
  novemberData,
  decemberData
];

// Combine all monthly reports into YTD data
const combinedData = combineReports(allMonthlyReports, 'YTD Report 2025');

// Export the YTD data with proper period information
export const ytdData: ReportData = {
  ...combinedData,
  period: {
    month: 12, // Current month for YTD
    startMonth: 1,
    endMonth: 12, // Update this when adding new months
    year: 2025,
    ytd: true
  }
};